import React, { useEffect, useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BsFacebook, BsLinkedin, BsInstagram, BsGithub } from 'react-icons/bs';
import Clock from 'react-live-clock';
import Wave from 'react-wavify';
import { useLanguage } from '../../context/LanguageContext';





const Footer = () => {


    const { language } = useLanguage()

    const time = new Date();

    const handleDone = () => {
        console.log(`Done after 5 loops!`)
    }

    useEffect(() => {
        AOS.init({
            duration: 2000
        })
    }, [])


    return (
        <div className='print:hidden mt-80'>
            <footer className="pb-6 ">

                {
                    language === 'english' ?
                        <>
                            <h1 className='text-lg text-center'>Copyright © {time.getFullYear()} | All Rights Reserved By <br></br> <span className='text-3xl font-bold'>
                                <Typewriter
                                    words={[
                                        'Fahim Faysal'
                                    ]}
                                    loop={500}
                                    cursor
                                    cursorStyle='|'
                                    typeSpeed={100}
                                    deleteSpeed={80}
                                    delaySpeed={1000}
                                    onLoopDone={handleDone}
                                />
                            </span>
                            </h1>
                        </>
                        :
                        <>
                            <h1 className='text-lg text-center'>কপিরাইট © {time.getFullYear()} | সমস্ত অধিকার সংরক্ষিত <br></br>
                                <span className=' text-3xl font-bold'>

                                    <Typewriter
                                        words={[
                                            'ফাহিম ফয়সাল'
                                        ]}
                                        loop={500}
                                        cursor
                                        cursorStyle='|'
                                        typeSpeed={100}
                                        deleteSpeed={80}
                                        delaySpeed={1000}
                                        onLoopDone={handleDone}
                                    />
                                </span>
                            </h1>
                        </>
                }

                {
                    language === 'english' ?
                        <div className="divider w-3/4 mx-auto">Be Happy And Keep Everyone Happy</div>
                        :
                        <div className="divider w-3/4 mx-auto">সুখী থাকুন এবং সবাইকে খুশি রাখুন</div>
                }

                <div className='flex justify-center items-center gap-x-4 -mt-2'>

                    <div className=''>
                        <a href='https://www.facebook.com/fahim.sakib.5' target='blank' className='tooltip' data-tip='Facebook'>
                            <BsFacebook className='text-2xl my-2 hover:text-blue-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsFacebook>
                        </a>
                    </div>

                    <div className=''>
                        <a href='https://github.com/Fahimsakib1?tab=repositories' target='blank' className='tooltip' data-tip='GitHub'>
                            <BsGithub className='text-2xl my-2 hover:bg-black hover:text-white rounded-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsGithub>
                        </a>
                    </div>

                    <div className=''>
                        <a href='https://www.linkedin.com/in/fahim-faysal/' target='blank' className='tooltip' data-tip='LinkedIn'>
                            <BsLinkedin className='text-2xl my-2 hover:text-blue-700 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsLinkedin>
                        </a>
                    </div>

                    <div className=' '>
                        <a href='https://www.instagram.com/i_fahiim/' target='blank' className='tooltip' data-tip='Instagram'>
                            <BsInstagram className='text-2xl my-2 hover:text-rose-500 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></BsInstagram>
                        </a>
                    </div>
                </div>

                {/* <div className='text-center '>
                    <Clock format={'HH:mm:ss A'} ticking={true} className='text-2xl text-center' />
                </div> */}

                <Wave className='-mt-6  h-[35px]' mask="url(#mask)" fill="#650c7b" >
                    <defs>
                        <linearGradient id="gradient" gradientTransform="rotate(90)">
                            <stop offset="0" stopColor="white" />
                            <stop offset="0.5" stopColor="black" />
                        </linearGradient>
                        <mask id="mask">
                            <rect x="0" y="0" width="2200" height="170" fill="url(#gradient)" />
                        </mask>
                    </defs>
                </Wave>

            </footer>

































        </div>
    );
};

export default Footer;